import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { BrMaskerModule } from 'br-mask';
import { TooltipModule } from 'ng2-tooltip-directive';
import { IonicModule } from '@ionic/angular';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCInputModule } from '@wlp/ui-c-input';

let UiCEmitBilletChargingV1Component = class UiCEmitBilletChargingV1Component {
    constructor() {
        this.billetChargingValue = 3;
        this.confirm = new EventEmitter();
        this.checkForm = new EventEmitter();
        this.checkDate = new EventEmitter();
        this.checkedToggle = new EventEmitter();
        this.descripitonLength = 0;
        this.orderNumLength = 0;
        this.billetBodyObsLength = 0;
    }
    ngOnInit() {
        this.toogleFavorite = false;
        if (!this.textButton) {
            this.textButton = 'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.BUTTON.CONFIRM';
        }
    }
    descriptionLength(value) {
        let description = value.detail.value;
        this.descripitonLength = description.length;
    }
    orderNumberLength(value) {
        let number = value.detail.value;
        this.orderNumLength = number.length;
    }
    billetBodyObservationsLength(value) {
        console.log(value);
        let obs = value.detail.value;
        this.billetBodyObsLength = obs.length;
    }
    confirmEmit() {
        let data = this.billetChargingForm.getRawValue();
        this.confirm.emit(data);
    }
    checkInput(data) {
        this.checkForm.emit(data);
    }
    checkInputDate(data) {
        this.checkDate.emit(data);
    }
    checkToggle($event) {
        this.checkedToggle.emit($event.detail.checked);
    }
};
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], UiCEmitBilletChargingV1Component.prototype, "billetChargingForm", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCEmitBilletChargingV1Component.prototype, "errorMessages", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCEmitBilletChargingV1Component.prototype, "billetChargingValue", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCEmitBilletChargingV1Component.prototype, "confirm", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCEmitBilletChargingV1Component.prototype, "checkForm", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCEmitBilletChargingV1Component.prototype, "checkDate", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCEmitBilletChargingV1Component.prototype, "checkedToggle", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCEmitBilletChargingV1Component.prototype, "showToggle", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCEmitBilletChargingV1Component.prototype, "textButton", void 0);
UiCEmitBilletChargingV1Component = __decorate([
    Component({
        selector: 'ui-c-emit-billet-charging-v1',
        template: "<ng-container class=\"ui-c-imit-billet-charging\">\n  <form [formGroup]=\"billetChargingForm\">\n    <ion-row class=\"ion-justify-content-left ion-align-items-center\">\n      <ui-c-input [form]=\"billetChargingForm\" [errorMessages]=\"errorMessages\" [formName]=\"'nameComplete'\"\n        [placeholder]=\"'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.FULL_NAME' | wlpTranslate\"\n        [name]=\"'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.FULL_NAME' | wlpTranslate\">\n      </ui-c-input>\n\n\n      <ui-c-input [form]=\"billetChargingForm\" [errorMessages]=\"errorMessages\" [formName]=\"'email'\"\n        [placeholder]=\"'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.EMAIL' | wlpTranslate\"\n        [name]=\"'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.EMAIL' | wlpTranslate\">\n      </ui-c-input>\n\n      <ui-c-input [form]=\"billetChargingForm\" [errorMessages]=\"errorMessages\" [formName]=\"'document'\"\n        [placeholder]=\"'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.CPF_CNPJ' | wlpTranslate\" [isPerson]=\"true\"\n        [name]=\"'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.CPF_CNPJ' | wlpTranslate\"></ui-c-input>\n\n      <ui-c-input [form]=\"billetChargingForm\" [errorMessages]=\"errorMessages\" [formName]=\"'billetBodyObservations'\"\n        [maxlength]=\"120\" (ionChange)=\"billetBodyObservationsLength($event)\"\n        [placeholder]=\"'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.COMMENTS' | wlpTranslate\"\n        [name]=\"'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.COMMENTS' | wlpTranslate\"></ui-c-input>\n      <p>{{billetBodyObsLength}}/120</p>\n\n      <ui-c-input [form]=\"billetChargingForm\" [errorMessages]=\"errorMessages\" [formName]=\"'orderNumber'\"\n        [maxlength]=\"20\" (ionChange)=\"orderNumberLength($event)\"\n        [placeholder]=\"'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.ORDER_NUMBER' | wlpTranslate\"\n        [name]=\"'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.ORDER_NUMBER' | wlpTranslate\"></ui-c-input>\n      <p>{{orderNumLength}}/20</p>\n\n      <ui-c-input [form]=\"billetChargingForm\" [errorMessages]=\"errorMessages\" [formName]=\"'descripiton'\"\n        [maxlength]=\"200\" (ionChange)=\"descriptionLength($event)\"\n        [placeholder]=\"'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.DESCRIPTION' | wlpTranslate\"\n        [name]=\"'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.DESCRIPTION' | wlpTranslate\"></ui-c-input>\n      <p>{{descripitonLength}}/200</p>\n\n      <ui-c-input [form]=\"billetChargingForm\" [errorMessages]=\"errorMessages\" [formName]=\"'dateDue'\" [isDate]=\"true\"\n        [placeholder]=\"'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.EXPIRATION_BANK_SLIP' | wlpTranslate\"\n        [name]=\"'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.EXPIRATION_BANK_SLIP' | wlpTranslate\">\n      </ui-c-input>\n\n      <ui-c-input [form]=\"billetChargingForm\" [errorMessages]=\"errorMessages\" [formName]=\"'billetValue'\"\n        (ionChange)=\"checkInput($event)\" [isMoney]=\"true\"\n        [placeholder]=\"'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.VALUE_TO_INFORM' | wlpTranslate\"\n        [name]=\"'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.VALUE_TO_INFORM' | wlpTranslate\">\n      </ui-c-input>\n\n\n      <div class=\"confirm mt-2\">\n        <div *ngIf=\"showToggle\" class=\"div-toggle d-flex align-items-center justify-content-center\">\n          <p class=\"mr-2 text-card\">{{ 'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.SAVE_TO_FAVORITES' | wlpTranslate }}\n          </p>\n          <ion-toggle (ionChange)=\"checkToggle($event)\" [disabled]=\"!billetChargingForm.valid\" mode=\"ios\"\n            color=\"success\">\n          </ion-toggle>\n        </div>\n\n        <ui-c-button [disabled]=\"!billetChargingForm.valid\" (continue)=\"confirmEmit()\" class=\"ion-button-success\"\n          expand=\"block\">{{'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.BUTTON.CONFIRM' | wlpTranslate}}</ui-c-button>\n        <p class=\"text-center text-card mt-3 mb-5\">\n          {{ 'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.BILL_COST' | wlpTranslate }} {{billetChargingValue | currency:\n          'BRL'}}\n        </p>\n      </div>\n    </ion-row>\n  </form>\n</ng-container>",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCEmitBilletChargingV1Component);

let UiCEmitBilletChargingV1Module = class UiCEmitBilletChargingV1Module {
};
UiCEmitBilletChargingV1Module = __decorate([
    NgModule({
        declarations: [UiCEmitBilletChargingV1Component],
        imports: [
            CommonModule,
            IonicModule,
            ReactiveFormsModule,
            TooltipModule,
            BrMaskerModule,
            UiBsTranslateModule,
            UiCButtonModule,
            FormsModule,
            UiCInputModule
        ],
        exports: [UiCEmitBilletChargingV1Component]
    })
], UiCEmitBilletChargingV1Module);

export { UiCEmitBilletChargingV1Component, UiCEmitBilletChargingV1Module };
//# sourceMappingURL=wlp-ui-c-emit-billet-charging-v1.js.map
